module.exports = __webpack_public_path__ + "img/block-1.6673fc20.png";